import { RootState } from '@iwProvider/configureStore';

export const getOpenBankingBanks = ({ siteContext }: RootState) =>
    siteContext.openBankingBanks;

export const getTrueLayerBanks = ({ siteContext }: RootState) =>
    siteContext.truelayerBanks;
